import React, { useCallback, useMemo } from 'react';
import { Box, Tab, Tabs } from 'extended-oxygen-elements';
import { DayOfWeek, DAYS_OF_WEEK } from '../types';
import { tabContainerStyles, tabsStyles } from '../styles/tabStyles';

type LocationTabsProps = {
  selectedDay: DayOfWeek;
  onDayChange: (day: DayOfWeek) => void;
};

export function LocationTabs({ selectedDay, onDayChange }: LocationTabsProps) {
  // Memoize the selected index to avoid recalculating
  const selectedIndex = useMemo(
    () => DAYS_OF_WEEK.findIndex(day => day.value === selectedDay),
    [selectedDay]
  );

  // Memoize the change handler
  const handleChange = useCallback(
    (_event: React.SyntheticEvent, newValue: number) => {
      onDayChange(DAYS_OF_WEEK[newValue].value);
    },
    [onDayChange]
  );

  return (
    <Box sx={tabContainerStyles}>
      <Tabs
        value={selectedIndex}
        onChange={handleChange}
        variant="scrollable"
        scrollButtons="auto"
        aria-label="Select day of week to view duties"
        sx={tabsStyles}
      >
        {DAYS_OF_WEEK.map((day) => (
          <Tab
            key={day.value}
            label={day.label}
            id={`day-tab-${day.value}`}
            aria-controls={`day-panel-${day.value}`}
          />
        ))}
      </Tabs>
    </Box>
  );
}
